import SuccessStep from "./components/SuccessStep";
import { IConfigureStep } from "./types";

const finished: IConfigureStep = {
  title: "You're all done!",
  description:
    "You’ve successfully configured your wallet for transacting on the Palm Network. You can now use the token bridge to get assets on the Palm Network.",
  buttonGoBack: false,
  buttonNext: true,
  buttonNextLabel: "Go to the homepage",
  finished: true,
  StepComponent: SuccessStep,
};

export default finished;
